@if (limitReached && inProTier) {
  <div class="d-flex flex-column text-muted">
    @if (hasUserAdminAccess) {
      <span>Resource limit reached:</span>
      <span class="d-flex align-items-center">
        <a class="link-light link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
          href="/billing" type="button">
          Manage here
        </a>
        <i class="ms-auto fa-solid fa-lock text-muted"></i>
      </span>
    } @else {
      <span>Resource limit reached: Contact your</span>
      <span>administrator to increase capacity
        <i class="fa-solid fa-lock"></i>
      </span>
    }
  </div>
}